// Enhanced search functionality that integrates typing effect with existing search forms
if (!window.searchEnhancementsLoaded) {
  window.searchEnhancementsLoaded = true;

  // Wait for both search-form.js and predictive-search.js to load
  const initializeEnhancedSearch = () => {
    // Check if typing effect is enabled - include mobile search forms
    const searchForms = document.querySelectorAll('.header-search-form.typing-enabled, .header-search-form-mobile.typing-enabled, .search-modal__form.typing-enabled');
    
    searchForms.forEach(form => {
      const searchInput = form.querySelector('input[type="search"]');
      if (!searchInput || searchInput.hasAttribute('data-typing-initialized')) return;
      
      // Mark as initialized to prevent duplicate initialization
      searchInput.setAttribute('data-typing-initialized', 'true');
      
      // Get typing configuration from data attributes
      const phrasesData = form.dataset.typingPhrases;
      let phrases = ['100% whey protein']; // Default phrase
      
      if (phrasesData) {
        try {
          phrases = JSON.parse(phrasesData);
        } catch (e) {
          console.warn('Invalid typing phrases data:', e);
        }
      }
      
      // Initialize typing effect
      const typingEffect = new SearchTypingEffect(searchInput, {
        phrases: phrases,
        typeSpeed: parseInt(form.dataset.typeSpeed) || 50,
        deleteSpeed: parseInt(form.dataset.deleteSpeed) || 30,
        pauseDuration: parseInt(form.dataset.pauseDuration) || 2000,
        startDelay: parseInt(form.dataset.startDelay) || 500
      });
      
      // Store reference for cleanup
      form.typingEffect = typingEffect;
    });
  };

  // Initialize when DOM is ready and custom elements are defined
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      // Wait a bit for custom elements to be fully initialized
      setTimeout(initializeEnhancedSearch, 100);
    });
  } else {
    // DOM is already loaded
    setTimeout(initializeEnhancedSearch, 100);
  }

  // Re-initialize when new search forms are added dynamically
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { // Element node
          if (node.matches && (
            node.matches('.header-search-form.typing-enabled') ||
            node.matches('.header-search-form-mobile.typing-enabled') ||
            node.matches('.search-modal__form.typing-enabled')
          )) {
            setTimeout(initializeEnhancedSearch, 100);
          } else if (node.querySelector) {
            const forms = node.querySelectorAll('.header-search-form.typing-enabled, .header-search-form-mobile.typing-enabled, .search-modal__form.typing-enabled');
            if (forms.length > 0) {
              setTimeout(initializeEnhancedSearch, 100);
            }
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}